import { render, staticRenderFns } from "./LastElement.vue?vue&type=template&id=4749e002&scoped=true&"
import script from "./LastElement.vue?vue&type=script&lang=js&"
export * from "./LastElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4749e002",
  null
  
)

export default component.exports